"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyHandlerBase = void 0;
const chain_base_1 = require("../../../chain-base");
class StrategyHandlerBase extends chain_base_1.ChainBase {
    /**
     * Get the strategy address and params for the provided strategy ID
     * @param strategyId The strategy ID
     */
    async getStrategyAddressAndParams(strategyId) {
        // [strategy_addr, strategy_params_len, ...strategy_params]
        const { result } = await this._starknet.callContract({
            contractAddress: this._addresses.starknet.strategyRegistry,
            entrypoint: 'get_strategy',
            calldata: [strategyId],
        });
        return { addr: result[0], params: result.slice(2) };
    }
}
exports.StrategyHandlerBase = StrategyHandlerBase;
